module.exports = __webpack_public_path__ + "img/share.02df9ec5.svg";